import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";
import { useQueryClient } from "@tanstack/react-query";
import { getIsActiveFromFormData } from "../../utils/parseIsActive";

export const useIndustryUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body, params }) => {
      const config = {};
      if (params) config.params = params;
      // Only set multipart header when sending FormData
      if (body instanceof FormData) {
        config.headers = { "Content-Type": "multipart/form-data" };
      }
      const res = await api.put(`/industry/update/${id}`, body ?? undefined, config);
      return res.data;
    },
    onSuccess: (_data, variables) => {
      const submittedActive = getIsActiveFromFormData(variables?.body);
      const industryId = variables?.id;

      if (industryId && variables?.body instanceof FormData) {
        queryClient.setQueryData(["viewIndustry"], (old) => {
          const patchList = (list) =>
            list.map((item) => {
              const id = item?._id || item?.id;
              if (id !== industryId) return item;
              return {
                ...item,
                isActive: submittedActive,
                status: submittedActive ? "Active" : "Inactive",
              };
            });

          const oldList =
            old?.data?.industry ||
            old?.data ||
            old?.industry ||
            (Array.isArray(old) ? old : null);

          if (!Array.isArray(oldList)) return old;

          const nextList = patchList(oldList);

          if (old && typeof old === "object" && !Array.isArray(old)) {
            if (Array.isArray(old.data)) return { ...old, data: nextList };
            if (
              old.data &&
              typeof old.data === "object" &&
              Array.isArray(old.data.industry)
            ) {
              return { ...old, data: { ...old.data, industry: nextList } };
            }
            if (Array.isArray(old.industry)) {
              return { ...old, industry: nextList };
            }
            return { ...old, data: nextList };
          }

          return nextList;
        });
      }

      queryClient.invalidateQueries({ queryKey: ["viewIndustry"] });
      // Refresh the single industry page (if user is viewing it)
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: ["industry", variables.id] });
      }
    },
  });
};

